module.exports = __webpack_public_path__ + "static/media/GiuseppeToniolo.78030606.jpg";